import React from 'react';
import classNames from 'classnames';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

import './ChatFileRowPlaceholder.styles.scss';

type ChatFileRowPlaceholderProps = {
  className?: string;
  /** the modal row carries the Data Room status chip; the sidebar row does not */
  withStatus?: boolean;
};

const COMMON: Partial<IContentLoaderProps> = {
  backgroundColor: '#e7f1fc',
  foregroundColor: '#ffffff',
};

/**
 * Stands in for a `ChatFileRow` while a new bucket or search loads, so the list keeps the
 * height it had instead of collapsing around a loader.
 *
 * One wide loader can't fill the row without either centering itself or distorting the
 * icon, so the placeholder mirrors the row's flex layout: a fixed icon, a stretchy text
 * block (`preserveAspectRatio="none"` lets the bars fill the row) and a fixed status chip.
 */
const ChatFileRowPlaceholder: React.FC<ChatFileRowPlaceholderProps> = (
  props,
) => {
  const { className, withStatus } = props;

  const classes = classNames('chat-file-row-placeholder', className);

  return (
    <li className={classes}>
      <ContentLoader
        className="chat-file-row-placeholder__icon"
        viewBox="0 0 24 24"
        {...COMMON}
      >
        <rect x="0" y="0" rx="4" ry="4" width="24" height="24" />
      </ContentLoader>

      <ContentLoader
        className="chat-file-row-placeholder__text"
        viewBox="0 0 400 36"
        preserveAspectRatio="none"
        {...COMMON}
      >
        <rect x="0" y="1" rx="2" ry="2" width="220" height="16" />
        <rect x="0" y="23" rx="2" ry="2" width="120" height="12" />
      </ContentLoader>

      {withStatus && (
        <ContentLoader
          className="chat-file-row-placeholder__status"
          viewBox="0 0 100 20"
          {...COMMON}
        >
          <rect x="0" y="0" rx="4" ry="4" width="100" height="20" />
        </ContentLoader>
      )}
    </li>
  );
};

export default ChatFileRowPlaceholder;
